import * as pc from 'playcanvas';
import type { Vec3 } from '@viewer/overlay/measureTypes';

const PICKER_SCALE = 0.5;

/** PlayCanvas Picker wrapper — same approach as engine picking.example.mjs / Château. */
export class GsplatMeasurePicker {
  private picker: pc.Picker | null = null;
  private idsEnabled = false;
  private pickInFlight = false;

  constructor(
    private readonly app: pc.AppBase,
    private readonly canvas: HTMLCanvasElement,
    private readonly camera: pc.CameraComponent,
  ) {}

  dispose(): void {
    this.picker = null;
  }

  isBusy(): boolean {
    return this.pickInFlight;
  }

  pick(clientX: number, clientY: number): Promise<Vec3 | null> {
    const rect = this.canvas.getBoundingClientRect();
    const localX = clientX - rect.left;
    const localY = clientY - rect.top;
    if (localX < 0 || localY < 0 || localX > rect.width || localY > rect.height) {
      return Promise.resolve(null);
    }

    const gs = this.app.scene.gsplat;
    if (!gs) return Promise.resolve(null);

    if (!this.idsEnabled) {
      this.idsEnabled = true;
      gs.enableIds = true;
    }

    if (!this.picker) {
      this.picker = new pc.Picker(this.app, 1, 1, true);
    }

    const w = Math.max(1, Math.floor(rect.width * PICKER_SCALE));
    const h = Math.max(1, Math.floor(rect.height * PICKER_SCALE));
    this.picker.resize(w, h);

    const worldLayer = this.app.scene.layers.getLayerByName('World');
    this.picker.prepare(this.camera, this.app.scene, worldLayer ? [worldLayer] : undefined);

    const sx = localX * PICKER_SCALE;
    const sy = localY * PICKER_SCALE;
    this.pickInFlight = true;

    return this.picker
      .getWorldPointAsync(sx, sy)
      .then((pt) => {
        this.pickInFlight = false;
        return pt ? { x: pt.x, y: pt.y, z: pt.z } : null;
      })
      .catch(() => {
        this.pickInFlight = false;
        return null;
      });
  }
}
